import formas_pago from "./formas_pago";
import modalidades from "./modalidades";

export default {
  formas_pago,
  modalidades,
};
